import { businessKey } from 'queryKeys';

const query = businessKey.query('customAudiences');

export const actionsLog = query.exact('LOG');
